module.exports = __webpack_public_path__ + "static/media/sf_attraction_winery.77b82632.jpg";